export default function isElementInScrollRange(element) {
  const bcr = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  return bcr.top <= viewportHeight && bcr.bottom >= 0; // bottom && top
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/misc/isElementInScrollRange.js
// module id = 27
// module chunks = 0